import SuperFetch from '../../superFetch.js';

class CouponApi {
  /**
   *  [쿠폰 리스트] 쿠폰 리스트 요청하기
   */
  getCouponList = (data) => SuperFetch.post('/coupon/list', data);

  /**
   *  [쿠폰 리스트] 쿠폰 리스트 엑셀 다운로드 요청하기
   */
  getCouponListExcelDownload = (data) => SuperFetch.post('/coupon/list/excel/download', data);

  /**
   *  [쿠폰 생성] 쿠폰 생성하기
   */
  insertCoupon = (data) => SuperFetch.post('/coupon/insert', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 요청하기
   */
  getCouponProductItemList = (data) => SuperFetch.post('/coupon/insert/preparation/product/list', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 상품 아이템 리스트 엑셀 다운로드 요청하기
   */
  getCouponProductItemListExcelDownload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/product/list/excel/download', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 선택된 상품 아이템 리스트 엑셀 다운로드 요청하기
   */
  getSelectedCouponProductItemListExcelDownload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/product/list/excel/download/selected', data);

  /**
   *  [쿠폰 생성] 상품 리스트 엑셀 업로드 유효성 체크
   */
  checkValidCouponProductItemListExcelUpload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/product/list/excel/upload/check', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 요청하기
   */
  getCouponBrandItemList = (data) => SuperFetch.post('/coupon/insert/preparation/brand/list', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 아이템 리스트 엑셀 다운로드 요청하기
   */
  getCouponBrandItemListExcelDownload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/brand/list/excel/download', data);

  /**
   *  [쿠폰 생성] 쿠폰 별 쿠폰 적용 가능 브랜드 선택된 아이템 리스트 엑셀 다운로드 요청하기
   */
  getSelectedCouponBrandItemListExcelDownload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/brand/list/excel/download/selected', data);

  /**
   *  [쿠폰 생성] 브랜드 리스트 엑셀 업로드 유효성 체크
   */
  checkValidCouponBrandItemListExcelUpload = (data) =>
    SuperFetch.post('/coupon/insert/preparation/brand/list/excel/upload/check', data);

  /**
   *  [쿠폰 생성] 해당 브랜드에서 쿠폰 적용 가능 상품 리스트 가져오기
   */
  getCouponApplyAvailableProductList = (data) => SuperFetch.post('/coupon/insert/preparation/brand/product', data);

  /**
   *  [쿠폰 상세] 쿠폰 정보 가져오기
   */
  getCouponInfo = (data) => SuperFetch.post('/coupon/detail/info', data);

  /**
   *  [쿠폰 편집] 쿠폰 편집하기
   */
  editCoupon = (data) => SuperFetch.post('/coupon/edit', data);

  /**
   *  [쿠폰 상세] 쿠폰 상세 가져오기
   */
  getCouponDetail = (data) => SuperFetch.post('/coupon/detail', data);

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 요청하기
   */
  getCouponUsageHistoryList = (data) => SuperFetch.post('/coupon/detail/usage/history', data);

  /**
   *  [쿠폰 상세] 쿠폰 사용내역 리스트 엑셀 다운로드 요청하기
   */
  getCouponUsageHistoryListExcelDownload = (data) =>
    SuperFetch.post('/coupon/detail/usage/history/excel/download', data);

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 요청하기
   */
  getCouponUnUsageHistoryList = (data) => SuperFetch.post('/coupon/detail/unUsage/history', data);

  /**
   *  [쿠폰 상세] 쿠폰 미사용내역 리스트 엑셀 다운로드 요청하기
   */
  getCouponUnUsageHistoryListExcelDownload = (data) =>
    SuperFetch.post('/coupon/detail/unUsage/history/excel/download', data);

  /**
   * [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 상품 정보 가져오기
   */
  getCouponProductLinkList = (data) => SuperFetch.post('/coupon/detail/productLink', data);

  /**
   * [쿠폰 상세] 쿠폰별 쿠폰 적용 가능 브랜드 정보 가져오기
   */
  getCouponBrandLinkList = (data) => SuperFetch.post('/coupon/detail/brandLink', data);

  /**
   *  [쿠폰 발급] 발급할 쿠폰 리스트 가져오기
   */
  getGenerateSearchCouponList = (data) => SuperFetch.post('/coupon/generate/search/coupon', data);

  /**
   *  [쿠폰 발급] 검색으로 선택한 쿠폰 리스트 가져오기
   */
  getGenerateSearchCouponResult = (data) => SuperFetch.post('/coupon/generate/search/coupon/result', data);

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  getGenerateSearchUserList = (data) => SuperFetch.post('/coupon/generate/search/user', data);

  /**
   *  [쿠폰 발급] 쿠폰 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  getGenerateUserListExcelDownload = (data) => SuperFetch.post('/coupon/generate/search/user/excel/download', data);

  /**
   *  [쿠폰 발급] 쿠폰 발급 준비 데이터 가져오기
   */
  getPreparationCouponGenerate = (data) => SuperFetch.post('/coupon/generate/preparation', data);

  /**
   *  [쿠폰 발급] 쿠폰 발급 요청하기
   */
  generateCoupon = (data) => SuperFetch.post('/coupon/generate', data);

  /**
   *  [쿠폰 발급] 쿠폰 일괄 발급 엑셀 유효 체크
   */
  excelBulkGenerateCouponCheck = (data) => SuperFetch.post('/coupon/generate/bulk/check', data);

  /**
   *  [쿠폰 발급 내역 리스트] 쿠폰 발급 내역 리스트 요청하기
   */
  getCouponIssueHistoryList = (data) => SuperFetch.post('/coupon/issueHistory/list', data);

  /**
   * [쿠폰 발급 내역 상세] 쿠폰 발급 내역 상세 가져오기
   */
  getCouponIssueHistoryDetail = (data) => SuperFetch.post('/coupon/issueHistory/detail', data);

  /**
   *  [쿠폰 발급 내역 상세] 쿠폰 발급 리스트 가져오기
   */
  getCouponGeneratedList = (data) => SuperFetch.post('/coupon/issueHistory/detail/couponGenerated/list', data);
}

export default new CouponApi();
